import { generatePKCE, generateState } from './pkce';

const CLIENT_ID = import.meta.env.VITE_OAUTH_CLIENT_ID;
const AUTH_URL = import.meta.env.VITE_AUTH_URL;
const APP_URL = window.location.origin;

async function buildAuthUrl(
  mode: 'login' | 'signup',
  display: 'page' | 'popup' = 'page',
): Promise<string> {
  const { codeVerifier, codeChallenge } = await generatePKCE();
  const state = generateState();

  // Store in sessionStorage
  sessionStorage.setItem('oauth_state', state);
  sessionStorage.setItem('code_verifier', codeVerifier);

  const url = new URL(`${AUTH_URL}/oauth/authorize`);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('client_id', CLIENT_ID);
  url.searchParams.set('redirect_uri', `${APP_URL}/auth/callback`);
  url.searchParams.set('state', state);
  url.searchParams.set('code_challenge', codeChallenge);
  url.searchParams.set('code_challenge_method', 'S256');
  url.searchParams.set('scope', 'email profile');
  url.searchParams.set('product', 'optidev');
  url.searchParams.set('display', display);

  if (mode === 'signup') {
    url.searchParams.set('prompt', 'signup');
  }

  return url.toString();
}

export async function initiateLoginRedirect(returnUrl?: string): Promise<void> {
  // Store return URL for use after OAuth callback
  if (returnUrl) {
    sessionStorage.setItem('return_url', returnUrl);
  }

  const authUrl = await buildAuthUrl('login', 'page');
  window.location.href = authUrl;
}

export async function initiateSignupRedirect(returnUrl?: string): Promise<void> {
  // Store return URL for use after OAuth callback (same as login)
  if (returnUrl) {
    sessionStorage.setItem('return_url', returnUrl);
  }

  const authUrl = await buildAuthUrl('signup', 'page');
  window.location.href = authUrl;
}

export async function initiateLoginPopup(): Promise<Window | null> {
  const authUrl = await buildAuthUrl('login', 'popup');
  return openPopup(authUrl);
}

export async function initiateSignupPopup(): Promise<Window | null> {
  const authUrl = await buildAuthUrl('signup', 'popup');
  return openPopup(authUrl);
}

function openPopup(url: string): Window | null {
  const width = 500;
  const height = 700;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  const popup = window.open(
    url,
    'optiprime-auth',
    `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,status=no,menubar=no`,
  );

  if (!popup) {
    console.warn('Popup blocked - will fallback to redirect');
  }

  return popup;
}
